<template>
  <v-row dense>
    <v-col>
      <authorization permissionKey="exams_queue" can="read">
        <Attendances
          queueType="exam_waiting"
          :attendancePlaceId="attendancePlaceId"
        >
          <template v-slot:attendance="{ attendance }">
            <MedicalRequestQueue
              :attendance="attendance"
              queueType="exam_waiting"
            />
          </template>
        </Attendances>
      </authorization>
    </v-col>
  </v-row>
</template>

<script>
import Attendances from "@/components/queues/attendances.vue";
import MedicalRequestQueue from "@/components/medical_request/queue.vue";

export default {
  name: "WaitingExams",
  components: {
    Attendances,
    MedicalRequestQueue,
  },
  props: {
    attendancePlaceId: String,
  },
};
</script>

<style lang="scss" scoped></style>
